import { render, staticRenderFns } from "./chooseRole.vue?vue&type=template&id=5e49731d"
import script from "./chooseRole.vue?vue&type=script&lang=js"
export * from "./chooseRole.vue?vue&type=script&lang=js"
import style0 from "./chooseRole.vue?vue&type=style&index=0&id=5e49731d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports